module.exports = __webpack_public_path__ + "static/media/truck6.ecf112d9.jpg";